import { useMediaQuery, useTheme } from '@mui/material';
import { useContext, useEffect, useMemo } from 'react';

import { AuthContext } from '../../../contexts/AuthContext';
import { useError } from '../../../contexts/ErrorContext';
import { fullMenuItems } from '../helpers/helpers';
import type { ISidebarNav } from '../helpers/types';
import { useSidebarStore } from '../store/store';

export const useGetData = () => {
  const theme = useTheme();
  const reportError = useError();
  const { apiUser } = useContext(AuthContext);
  const { setCollapsed } = useSidebarStore();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    isMobile && setCollapsed(isMobile);
  }, [isMobile, setCollapsed]);

  const menuItems = useMemo(() => {
    const allowedSidebarNavBuild: ISidebarNav[] = [];
    try {
      const allowedPages = apiUser?.organization?.pages;
      if (allowedPages !== undefined) {
        fullMenuItems.map((navArray) => {
          if (navArray.children !== undefined && navArray.children.length > 0) {
            const allowedChildren: ISidebarNav[] = [];
            navArray.children.map((childArray) => {
              if (allowedPages.includes(childArray.key)) {
                allowedChildren.push(childArray);
              }
            });

            if (allowedChildren.length > 0) {
              const allowedNav = navArray;
              allowedNav.children = allowedChildren;
              allowedSidebarNavBuild.push(allowedNav);
            }
          } else {
            if (allowedPages.includes(navArray.key)) {
              allowedSidebarNavBuild.push(navArray);
            }
          }
        });
      }
    } catch (e) {
      reportError(e);
    }

    return allowedSidebarNavBuild;
  }, [apiUser?.organization?.pages, reportError]);

  return { menuItems };
};
